export default __webpack_public_path__ + "static/media/Pegasus2.5c204b64.png";